import type {
  FilterOptionsMap,
  FilterKeys,
} from '@op/components/FilterCommon/types';

const defaultFilterOptions: Array<FilterKeys> = [
  'date',
  'regionAndLanguage',
  'channel',
  'sentiment',
  'monitor',
  'topic',
  'invalid',
  'keyWords',
];

const defaultGameStoreFilterOptions: Array<FilterKeys> = [
  'date',
  'regionAndLanguage',
  'channel',
  'sentiment',
  'rating',
  'topic',
  'invalid',
  'keyWords',
];

export const socialFilterOptionsMap: FilterOptionsMap = {
  mobile: defaultFilterOptions,
  pc: defaultFilterOptions,
  console: defaultFilterOptions,
};

export const gameStoreFilterOptionsMap: FilterOptionsMap = {
  mobile: [...defaultGameStoreFilterOptions, 'version'],
  pc: [...defaultGameStoreFilterOptions, 'monitorSource'],
  console: [...defaultGameStoreFilterOptions, 'monitorSource', 'platform'],
};

export function beforeCacheDealwithData(cache: any) {
  // 不缓存渠道信息
  const { channel, channel_type, channels, ...otherInfo } = cache || {};
  let key = `channel_${channel_type}`;
  if (channel_type === 'security') {
    key = 'channel_securitys';
  }
  return { ...otherInfo, [key]: channel };
}

const sortListMap: { [key: string]: { text: string; value: string } } = {
  order_number: {
    value: 'order_number',
    text: 'Most Valuable',
  },
  important_score: {
    value: 'important_score',
    text: 'Hot',
  },
  relevance: {
    value: 'relevance',
    text: 'Relevance',
  },
  record_duration: {
    value: 'record_duration',
    text: 'Playtime on Record',
  },
  sort_isvalid: {
    value: 'sort_isvalid',
    text: 'Validation',
  },
  comment_time: {
    value: 'comment_time',
    text: 'Time',
  },
  ReleaseTime: {
    value: 'comment_time',
    text: 'Release Time',
  },
  engagement: {
    value: 'engagement',
    text: 'Engagement',
  },
  tweets_like: {
    value: 'tweets_like',
    text: 'Like',
  },
  Votes: {
    value: 'tweets_like',
    text: 'Votes',
  },
  tweets_unlike: {
    value: 'tweets_unlike',
    text: 'Dislike',
  },
  share: {
    value: 'share',
    text: 'Share-2',
  },
  tweets_reply: {
    value: 'tweets_reply',
    text: 'Comment',
  },
  view: {
    value: 'view',
    text: 'View',
  },
  version: { value: 'version', text: 'Version' },
  follower_number: {
    value: 'follower_number',
    text: 'Follower/Subscriber',
  },
  funny_num: {
    value: 'funny_num',
    text: 'Funny(people)',
  },
  helpful_num: {
    value: 'helpful_num',
    text: 'Helpful(people)',
  },
};

export function getSortOptions(sortKeys: Array<string>) {
  return sortKeys.map(item => sortListMap[item]).filter(Boolean);
}
